<template>
  <div class="container-fluid vh-100 bg-cover">
    <div class="row h-100">
      <div
        class="col-12 d-flex align-items-center justify-content-center text-center"
      >
        <div>
          <h1>Scan me</h1>
          <img
            :src="'https://clawmachine.nl/qrcode/?s=qr&sf=8&d=' + getUrl()"
            :title="getUrl()"
            width="450"
          />
          <h1>for a</h1>
          <h1>free game</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InactiveScreen",
  components: {},
  methods: {
    getUrl() {
      return process.env.VUE_APP_GAMEURL;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/custom.scss";
h1 {
  font-size: 120px;
  color: $text-color !important;
  padding-bottom: 20px;
  font-weight: 500;
  margin: 0;
}
img {
  padding-bottom: 20px;
  user-select: none;
  -webkit-user-drag: none;
  pointer-events: auto;
}
/* .outer {
  display: flex;
  align-items: center;
}
.center {
  margin: auto;
  padding: 10px;
} */
.screen {
  /* background: url("~@/assets/home_bg.png") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%; */
  overflow: hidden; /* Hide scrollbars */
}
.home-featured {
  font-weight: 200;
  /* background-color: #e0e493 !important; */
  /* background-image: linear-gradient(
    90deg,
    rgb(171, 224, 255) 0.72%,
    rgb(126, 196, 255) 99.4%
  ); */
  /* background-image: linear-gradient(to top right, purple, violet, orange); */
  background-size: 600% 600%;
  /* -webkit-animation: gradanimate 0.5s ease infinite; */
  /* animation: gradanimate 10s ease infinite; */
}
@-webkit-keyframes gradanimate {
  0% {
    background-position: 2% 0%;
  }
  50% {
    background-position: 99% 100%;
  }
  100% {
    background-position: 2% 0%;
  }
}
@keyframes gradanimate {
  0% {
    background-position: 2% 0%;
  }
  50% {
    background-position: 99% 100%;
  }
  100% {
    background-position: 2% 0%;
  }
}
</style>
